import React, { forwardRef } from 'react'

import { Label, LabelProps } from '@rebass/forms'
import { useSTheme } from 'styles/theme'

type FRadioLabel = LabelProps

const FRadioLabel = forwardRef<any, FRadioLabel>((props: FRadioLabel, ref) => {
    const theme = useSTheme()
    const fontFamily = theme.fontsV2[window.ORGANIZATION.name]?.body || theme.fontsV2.default

    const { sx, ...otherProps } = props

    return (
        <Label
            ref={ref}
            sx={{
                width: 'auto',
                fontWeight: '400',
                alignItems: 'center',
                marginBottom: '3px',
                textAlignLast: 'left',
                whiteSpace: 'pre-line',
                lineHeight: '140%',
                fontSize: '14px',
                color: theme.colors.gray400,
                fontFamily: fontFamily,
                ...sx,
            }}
            {...otherProps}
        />
    )
})

FRadioLabel.displayName = 'FRadioLabel'

export default FRadioLabel
